import { Divider } from 'antd'
import React, { useContext } from 'react'
import { BuilderContext } from '../../../store/store.Builder'
const DividerField = ({ field }) => {
  return <Divider />
}

export default DividerField
